<template>
  <div class="flex sharing-v">
    <Header />
    <div class="info-item">
      <div class="info-area wrapper">
        <h3 class="text-center">报名记录</h3>
      </div>
    </div>
    <div class="info-item">
      <div class="info-area area-box">
        <a-timeline>
          <a-timeline-item>
            <a-icon slot="dot" type="check-circle" />
            <div class="audit-info flex sharing-v">
              <span>我</span>
              <p class="flex sharing-h">
                <span>已提交报名申请</span>
                <span>{{ userInfo.submitDate }}</span>
              </p>
            </div>
          </a-timeline-item>
          <a-timeline-item>
            <a-icon
              slot="dot"
              type="check-circle"
              v-if="
                userInfo.currentStatus == 11 ||
                userInfo.currentStatus == 13 ||
                userInfo.currentStatus == 14
              "
              :style="userInfo.currentStatus >= 11 ? 'color:#B01F21' : ''"
            />
            <a-icon
              slot="dot"
              type="close-circle"
              v-if="userInfo.currentStatus == 12"
            />
            <div class="audit-info flex sharing-v">
              <span>初审</span>
              <p class="flex sharing-h">
                <span class="doing" v-if="userInfo.currentStatus == 10"
                  >审核中</span
                >
                <span
                  class="succeed"
                  v-if="
                    userInfo.currentStatus == 11 ||
                    userInfo.currentStatus == 13 ||
                    userInfo.currentStatus == 14
                  "
                  >审核通过</span
                >
                <span class="failed" v-if="userInfo.currentStatus == 12"
                  >审核不通过</span
                >
                <span
                  v-if="
                    userInfo.currentStatus == 11 || userInfo.currentStatus == 12
                  "
                  >{{ userInfo.updateByTime }}</span
                >
              </p>
              <a-alert
                v-if="userInfo.currentStatus == 12"
                :message="userInfo.comments"
                type="error"
              />
            </div>
          </a-timeline-item>
          <a-timeline-item :color="stepTwoColor">
            <a-icon
              slot="dot"
              type="check-circle"
              v-if="userInfo.currentStatus == 13"
              :style="userInfo.currentStatus == 13 ? 'color:#B01F21' : ''"
            />
            <a-icon
              slot="dot"
              type="close-circle"
              v-if="userInfo.currentStatus == 14"
            />
            <div class="audit-info flex sharing-v">
              <span>终审</span>
              <p class="flex sharing-h">
                <span class="doing" v-if="userInfo.currentStatus == 11"
                  >审核中</span
                >
                <span class="succeed" v-if="userInfo.currentStatus == 13"
                  >审核通过</span
                >
                <span class="failed" v-if="userInfo.currentStatus == 14"
                  >审核不通过</span
                >
                <span
                  v-if="
                    userInfo.currentStatus == 13 || userInfo.currentStatus == 14
                  "
                  >{{ userInfo.updateByTime }}</span
                >
              </p>
              <a-alert
                v-if="userInfo.currentStatus == 14"
                :message="userInfo.comments"
                type="error"
              />
            </div>
          </a-timeline-item>
        </a-timeline>
      </div>
    </div>

    <div class="next-box wrapper flex sharing-h">
      <p
        href="#"
        style="color: #b01f21; margin-right: 15px; text-align: center"
      >
        您已提交成功，请耐心等待，如有任何问题，请联系客服热线：021-5467 9196 或
        021-5467 9199
      </p>
    </div>
    <div class="next-box wrapper flex sharing-h">
      <a href="/infomation?lookMsg=1" style="color: #1890ff; margin-right: 15px"
        >查看我的报名信息
      </a>
      <a
        v-if="
          (userInfo.currentStatus == 14 || userInfo.currentStatus == 12) &&
          userLoginInfo.overExamDate != 1
        "
        href="/authent"
        style="color: #1890ff"
        >重新发起申请</a
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("apply");
export default {
  name: "Login",
  components: {
    Header
  },
  data() {
    return {
      needUpdate: false,
      userInfo: {},
      userLoginInfo: {},
      stepTwoColor: '#ccc',
    };
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
    this.userLoginInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
    this.getStudentInfo({
      orderCode: userInfo.orderCode,
      userCode: userInfo.userCode,
      examCode: userInfo.examCode,
    }).then(res => {
      let studentInfo = res.data.data;
      this.userInfo = studentInfo;

      if (studentInfo.currentStatus == 11 || studentInfo.currentStatus == 13 || studentInfo.currentStatus == 14) {

        this.stepTwoColor = '#B01F21'
      }
    });
  },
  methods: {
    ...mapActions([
      "getStudentInfo",
    ]),
    handleChange(checked) {
      console.log(checked);
    }
  }
};
</script>

<style scoped>
.next-box {
  margin-top: 30px;
  justify-content: center;
}
.info-item {
  margin-top: 20px;
}
.info-item h3 {
  margin-bottom: 0;
  font-size: 20px;
  font-weight: bold;
}
.info-area {
  padding: 30px;
  background: #f9f9f9;
}
.info-area h4 {
  font-weight: bold;
  text-align: left;
}
.info-area img {
  width: 100%;
}
.info-area .img-title {
  text-align: center;
  margin-bottom: 15px;
}
.info-area .avatar-img {
  width: 100px;
}
.area-box {
  box-sizing: border-box;
}
.audit-info {
  align-items: stretch;
}
.doing {
  color: #1890ff;
}
.succeed {
  color: #46b01f;
}
.failed {
  color: #b01f21;
}
</style>